import React, {FC, ReactNode, RefObject} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

export interface PageWrapperProps {
  header?: ReactNode;
  pageTabs?: ReactNode;
  footer?: ReactNode;
  sideContent?: ReactNode;
  outerRef?: RefObject<HTMLDivElement>;
}

/*
 * Styles.
 */

const StyledWrapperDiv = styled.div`
  display: flex;
  height: inherit;
  flex: 1;
`;

const StyledTabsWrapperDiv = styled.div`
  border-bottom: 1px solid ${(p) => p.theme.greys.shade30};
  display: flex;
  gap: 8px;
  padding: 13px 48px 0 48px;
  margin-bottom: 12px;
`;

const StyledScrollableDiv = styled.div`
  overflow: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const StyledContentWrapperDiv = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column;
  padding: 4px 48px 48px 48px;
  min-width: 696px;
`;

const StyledFooterDiv = styled.div`
  :before {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: 48px;
    left: 48px;
    height: 1px;
    background: #e6e6e6;
  }
  display: flex;
  justify-content: flex-end;
  padding: 16px 48px;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${(p) => p.theme.greys.white};
`;

/*
 * Component.
 */

export const PageWrapper: FC<PageWrapperProps> = ({
  header,
  pageTabs,
  footer,
  sideContent,
  children,
  outerRef,
}) => (
  <StyledScrollableDiv ref={outerRef}>
    {header}
    {pageTabs && <StyledTabsWrapperDiv>{pageTabs}</StyledTabsWrapperDiv>}
    <StyledWrapperDiv>
      <StyledContentWrapperDiv>{children}</StyledContentWrapperDiv>
      {sideContent}
    </StyledWrapperDiv>
    {footer && <StyledFooterDiv>{footer}</StyledFooterDiv>}
  </StyledScrollableDiv>
);
